import { Disclosure, DisclosurePanel } from '@headlessui/react'
import { DisclosureButton, IconBullseyeRegular, IconCubes } from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'

import { InnerTagStyledDiv, NavItemStyledDiv, OuterTagStyledDiv } from './StyledDivs'
import { ApiSubNavSchema } from '../ApiSubNavSchema'
import { ApiSubNavOperation } from '~/components/ConsumerSideNavigation/ApiNavItem/ApiSubNavOperation'
import { API_TYPE, Operation, Schema } from '~/types/content'

export const ApiSubNav = ({
  tag,
  operations,
  schemas,
  active = false,
  parentPath,
  level,
  selectedOperationOrSchema,
  setSelectedOperationOrSchema,
  onClick,
  apiType,
}: {
  tag?: string,
  operations?: Operation[],
  schemas?: Schema[],
  active?: boolean,
  parentPath: string,
  level: number,
  selectedOperationOrSchema?: string | null,
  setSelectedOperationOrSchema: (selectedOperationOrSchema: string | null) => void,
  onClick?: (e) => void,
  apiType?: API_TYPE
}) => {
  const { t } = useTranslation()

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div className="text-body3 text-neutral-70 dark:text-neutral-30">
          <OuterTagStyledDiv>
            <div className={clsx(active && 'separator h-[7px]')} />
            <InnerTagStyledDiv active={active} level={level}>
              <DisclosureButton
                open={open}
                className={clsx(
                  '!justify-end flex-row-reverse gap-2 px-1.5',
                  active ? 'py-0.5 mb-[7px]' : 'py-[9px]',
                )}
              >
                <span className="pr-4 text-left">{tag || t('consumer.product.side.navigation.api.operations')}</span>
                <span className="pl-1 text-neutral-60 dark:text-neutral-40">
                  {operations ? <IconBullseyeRegular width={12} height={12} /> : <IconCubes />}
                </span>
              </DisclosureButton>
            </InnerTagStyledDiv>
          </OuterTagStyledDiv>
          <DisclosurePanel>
            {operations && operations.map((operation, index) => (
              <NavItemStyledDiv
                operation={operation}
                lastItem={index === operations.length - 1}
                index={index}
                active={active}
                level={level}
                key={operation.path + operation.method}
                operationsLength={operations.length}
                isSelected={(selectedOperationOrSchema === (operation.operationId + operation.path + operation.method)) && active}
              >
                <ApiSubNavOperation
                  operation={operation}
                  active={active}
                  parentPath={parentPath}
                  isSelected={(selectedOperationOrSchema === (operation.operationId + operation.path + operation.method)) && active}
                  setSelectedOperation={setSelectedOperationOrSchema}
                  onClick={onClick}
                />
              </NavItemStyledDiv>
            ))}
            {schemas && schemas.map((schema, index) => (
              <NavItemStyledDiv
                operation={schema}
                lastItem={index === schemas.length - 1}
                index={index}
                active={active}
                level={level}
                key={schema.title || schema.name}
                operationsLength={schemas.length}
                isSelected={(selectedOperationOrSchema === (schema.name)) && active}
              >
                <ApiSubNavSchema
                  schema={schema}
                  active={active}
                  parentPath={parentPath}
                  isSelected={(selectedOperationOrSchema === (schema.title || schema.name)) && active}
                  setSelectedSchema={setSelectedOperationOrSchema}
                  onClick={onClick}
                  apiType={apiType}
                />
              </NavItemStyledDiv>
            ))}
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  )
}